import React, { useEffect, useRef } from 'react';

import Pepsi from '../../assets/videos/PZS_Zero_never_tasted_so_good_06_16x9(2).mp4';

import { VideoPlayerProps } from './types';
import './video.css';

const VideoPlayer: React.FC<VideoPlayerProps> = ({ widthSize, heightSize }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    videoRef.current?.play();
  }, []);

  return (
    <div>
      <video
        controls
        disablePictureInPicture
        height={heightSize}
        ref={videoRef}
        width={widthSize}
      >
        <source src={Pepsi} type='video/mp4' />
      </video>
    </div>
  );
};

export default VideoPlayer;
